import { createReducer } from '@reduxjs/toolkit';
import { fetchStart, fetchStop } from '../actions';

export default createReducer(false, (builder) =>
  builder.addCase(fetchStart, () => true).addCase(fetchStop, () => false),
);
